import { Link } from 'react-router-dom';
import { getResolvedPath } from '../utils';
import ArtImageFallback from './ArtImageFallback';

const Artwork = ({ info }) => {
  const artistName = info.userDetails?.[0]
    ? `${info.userDetails[0].firstname} ${info.userDetails[0].lastname}`
    : 'Unknown artist';

  return (
    <article className="rounded-xl border border-gray-200 bg-white overflow-hidden shadow-sm hover:shadow-md transition-shadow flex flex-col h-full">
      <div className="aspect-square bg-gray-50 overflow-hidden">
        <ArtImageFallback
          src={getResolvedPath(info?.images?.[0])}
          alt={info.name || ''}
          className="object-contain w-full h-full"
          wrapperStyle={{ width: '100%', height: '100%' }}
        />
      </div>
      <div className="p-3 flex flex-col gap-2 flex-1">
        <h3 className="font-semibold text-gray-900 text-sm line-clamp-2">{info.name}</h3>
        <p className="text-xs text-gray-500 truncate">{artistName}</p>
        <p className="font-millerBanner text-ato-red font-semibold text-sm">
          $ {info.listed_price ?? '—'}
        </p>
        <div className="flex gap-2 mt-auto pt-2 border-t border-gray-100">
          <Link
            to={`/artwork/url/${info._id}`}
            className="flex-1 text-center text-xs py-2 rounded-lg bg-gray-900 text-white hover:bg-gray-800"
          >
            By URL
          </Link>
          <Link
            to={`/artwork/name/${info._id}`}
            className="flex-1 text-center text-xs py-2 rounded-lg border border-gray-300 text-gray-800 hover:bg-gray-50"
          >
            By Name
          </Link>
        </div>
      </div>
    </article>
  );
};

export default Artwork;
